"use strict";
/*
1) Initializes the share scope. This fills it with known provided modules from this build and all remotes
2) Initializes the container, it may provide shared modules
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadComponent = loadComponent;
exports.loadComponentLegacy = loadComponentLegacy;
const get_remote_1 = require("./get-remote");
function loadComponent(scope, module, url) {
    return () => __awaiter(this, void 0, void 0, function* () {
        yield (0, get_remote_1.getOrLoadRemote)(scope, url);
        // @ts-ignore
        const container = window[scope];
        const factory = yield container.get(module);
        return factory();
    });
}
// Older implementation that does not contain instance count, used for extensions
function loadComponentLegacy(scope, module) {
    return () => __awaiter(this, void 0, void 0, function* () {
        yield __webpack_init_sharing__('default');
        // @ts-ignore
        const container = window[scope];
        yield container.init(__webpack_share_scopes__.default);
        // @ts-ignore
        const factory = yield window[scope].get(module);
        const Module = factory();
        return Module;
    });
}
